import React, { useState, useEffect } from 'react';
import { useTranslation } from 'services/Translation';

const NAVY = '#1C165B';

const texts = (getText) => (key) =>
  ({
    title: getText('Log out?', 'Logout_Confirm'),
    message: getText('Are you sure you want to log out of your account?', 'Logout_Confirm'),
    cancel: getText('Cancel', 'Logout_Confirm'),
    confirm: getText('Log out', 'Logout_Confirm'),
  }[key]);

const LogoutButton = () => {
  const { t } = useTranslation(texts);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = () => {
    console.log('User logged out');
    localStorage.clear()
    window.location.href = "/";
  };

  // Allow dismissing the confirmation with the Escape key.
  useEffect(() => {
    if (!showConfirm) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setShowConfirm(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [showConfirm]);

  return (
    <>
      <button
        type="button"
        onClick={() => setShowConfirm(true)}
        aria-label={t('confirm')}
        style={{
          position: 'fixed',
          left: 0,
          top: '75%',
          transform: 'translateY(-50%)',
          zIndex: 1000,
          width: '60px',
          height: '60px',
          backgroundColor: NAVY,
          color: 'white',
          border: 'none',
          borderTopRightRadius: '30px',
          borderBottomRightRadius: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-power" viewBox="0 0 16 16">
          <path d="M7.5 1v7h1V1z" />
          <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
        </svg>
      </button>

      {showConfirm && (
        // Backdrop: click outside the card to dismiss. Keyboard dismissal is
        // handled via the Escape key listener above.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowConfirm(false);
          }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 100000,
            backgroundColor: 'rgba(28, 22, 91, 0.35)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
          }}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout-confirm-title"
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              padding: '2rem',
              width: '100%',
              maxWidth: '380px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
              fontFamily: 'coresanscr55',
              textAlign: 'center',
            }}
          >
            <div
              id="logout-confirm-title"
              style={{
                fontFamily: 'coresanscr65',
                fontSize: '1.125rem',
                color: NAVY,
                marginBottom: '0.5rem',
              }}
            >
              {t('title')}
            </div>
            <div style={{ fontSize: '0.875rem', color: '#4B5563', marginBottom: '1.5rem' }}>
              {t('message')}
            </div>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                type="button"
                onClick={() => setShowConfirm(false)}
                style={{
                  flex: 1,
                  padding: '0.625rem 1rem',
                  borderRadius: '10px',
                  border: `1px solid ${NAVY}`,
                  backgroundColor: 'white',
                  color: NAVY,
                  fontFamily: 'coresanscr55',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                }}
              >
                {t('cancel')}
              </button>
              <button
                type="button"
                onClick={handleLogout}
                style={{
                  flex: 1,
                  padding: '0.625rem 1rem',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: NAVY,
                  color: 'white',
                  fontFamily: 'coresanscr55',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                }}
              >
                {t('confirm')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LogoutButton;
